import http from './http';

let portalMode = null;
let fetchPromise = null;
// Bumped on every synchronous write so an in-flight fetch started before the
// write can detect it's now stale and avoid clobbering the newer value.
let writeGeneration = 0;
const listeners = new Set();

const notify = () => {
  listeners.forEach((listener) => listener());
};

export const getPortalModeSnapshot = () => portalMode;

export const subscribePortalMode = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

/**
 * Updates the shared portalMode value synchronously and notifies subscribers,
 * so any component reading it in the same SPA session sees the change
 * immediately, without waiting on a network round trip.
 */
export const setPortalMode = (nextPortalMode) => {
  writeGeneration += 1;
  portalMode = nextPortalMode;
  notify();
};

/**
 * Returns the current portalMode, fetching it from the server on first call.
 * Subsequent calls reuse the cached value/in-flight request.
 */
export const ensurePortalMode = () => {
  if (portalMode !== null) {
    return Promise.resolve(portalMode);
  }
  if (!fetchPromise) {
    const generation = writeGeneration;
    fetchPromise = http
      .getJSON('/wrapper/v1/portal-mode')
      .catch(() => ({}))
      .then((result) => {
        if (generation === writeGeneration) {
          portalMode = result;
          notify();
        }
        return portalMode;
      });
  }
  return fetchPromise;
};
